import React from "react";
import { Link } from "react-router-dom";

interface BreadcrumbItem {
  text: string;
  link?: string;
  onclick?: () => void;
}

interface BreadCrumbProps {
  items: BreadcrumbItem[];
}

const BreadCrumb: React.FC<BreadCrumbProps> = ({ items }) => {
  return (
    <div className="modern-breadcrumb">
      <ol className="breadcrumb m-0">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li
              key={index}
              className={`breadcrumb-item ${isLast ? "active" : ""}`}
            >
              {isLast ? (
                <span>{item.text}</span>
              ) : item.onclick ? (
                <span
                  onClick={item.onclick}
                  style={{ cursor: "pointer", color: "inherit" }}
                  className="breadcrumb-link"
                >
                  {item.text}
                </span>
              ) : item.link ? (
                <Link to={item.link}>{item.text}</Link>
              ) : (
                <span>{item.text}</span>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default BreadCrumb;
